import React from 'react'
import { Container, Row } from 'react-bootstrap'

export default class ExpiredShortcut extends React.Component {
  render () {
    const style = {
      width: '100%',
      color: 'white',
      background: '#959595',
      fontSize: 20,
      padding: 10,
      textAlign: 'center'
    }
    return (
      <Container>
        <Row style={{height: 20}}></Row>
        <div style={style}>
          We’re sorry, but the report you’re trying to access is no longer available. Please contact your Diesel Labs representative or <a href='mailto:support@diesellabs.com'>support@diesellabs.com</a> for more information.
        </div>
        <Row style={{height: 1000}}></Row>
      </Container>
    )
  }
}
